import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { useStyles } from './styles';
import AgentForm from './agent-form-new';
import GuarantorForm from './guarantor-form-new';
import { Route, Switch, BrowserRouter as Router, Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';


function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
        className="tabpanel-cover"
      >
        {value === index && <Box p={1}>{children}</Box>}
      </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};


function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
}


export default function EmergencyLoanFormTabs() {
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = React.useState(0);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  
    const handleChangeIndex = index => {
      setValue(index);
    };
  
    return (
      <div className="emer-loan-form-container">
          <div className="emer-loan-form-container-flex">
              <div className="emer-loan-form-container-item">
                <div className={`${classes.tabRoot} emer-loan-tabroot-cover`}>
                  <Router>
                    <Switch>
                      <Route exact path="/" render={(props) => (
                          <>
                            <AppBar position="static" color="default" className="appbar-cover">
                              <Tabs
                                value={value}
                                onChange={handleChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                                aria-label="full width tabs example"
                              >
                                <Tab label={
                                  <div className="tab-label-cover-flex">
                                    <p className="tab-label-text-item">Agent Form</p>
                                    <Button color="default" variant="contained" className="tab-label-text-item" href="/guarantor" target="_blank">Go To Guarantor Form</Button>
                                  </div>
                                } {...a11yProps(0)} className="appbar-tab-cover" />
                              </Tabs>
                            </AppBar>
                            <SwipeableViews
                              axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                              index={value}
                              onChangeIndex={handleChangeIndex}
                            >
                              <TabPanel value={value} index={0} dir={theme.direction}>
                                <AgentForm {...props} />
                              </TabPanel>
                            </SwipeableViews>
                          </>
                        )}
                      />
                      <Route path="/guarantor" render={(props) => (
                          <>
                            <AppBar position="static" color="default" className="appbar-cover">
                              <Tabs
                                value={value}
                                onChange={handleChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                                aria-label="full width tabs example"
                              >
                                <Tab label={
                                  <div className="tab-label-cover-flex">
                                    <p className="tab-label-text-item">Guarantor Form</p>
                                    {/* <Button color="default" variant="contained" className="tab-label-text-item" href="/">Agent Form</Button> */}
                                  </div>
                                } {...a11yProps(0)} className="appbar-tab-cover" />
                              </Tabs>
                            </AppBar>
                            <SwipeableViews
                              axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                              index={value}
                              onChangeIndex={handleChangeIndex}
                            >
                              <TabPanel value={value} index={0} dir={theme.direction} {...props}>
                                <GuarantorForm {...props} />
                              </TabPanel>
                            </SwipeableViews>
                          </>
                        )}
                      />
                    </Switch>
                  </Router>
                  
                </div>
              </div>
          </div>
      </div>
    );
}